<template>
  <Transition name="update-toast">
    <div v-if="updateAvailable" class="update-toast">
      <div class="update-toast__content">
        <div class="update-toast__icon">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
            <polyline points="7 10 12 15 17 10" />
            <line x1="12" y1="15" x2="12" y2="3" />
          </svg>
        </div>
        <span class="update-toast__text">A new version is available</span>
        <button class="update-toast__btn" @click="applyUpdate">
          Update now
        </button>
        <button class="update-toast__dismiss" @click="dismissUpdate" aria-label="Dismiss">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      </div>
    </div>
  </Transition>
</template>

<script setup>
import { useVersionCheck } from '../composables/useVersionCheck.js'

const { updateAvailable, applyUpdate, dismissUpdate } = useVersionCheck()
</script>

<style scoped>
.update-toast {
  position: fixed;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10000;
}

.update-toast__content {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background: #1f1f1f;
  color: #fff;
  border-radius: 10px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.24);
  font-size: 14px;
  white-space: nowrap;
}

.update-toast__icon {
  display: flex;
  color: #60a5fa;
  flex-shrink: 0;
}

.update-toast__text {
  flex-shrink: 0;
}

.update-toast__btn {
  background: #3b82f6;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 6px 14px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s;
  flex-shrink: 0;
}

.update-toast__btn:hover {
  background: #2563eb;
}

.update-toast__dismiss {
  background: none;
  border: none;
  color: #9ca3af;
  cursor: pointer;
  padding: 2px;
  display: flex;
  flex-shrink: 0;
}

.update-toast__dismiss:hover {
  color: #fff;
}

/* Transition */
.update-toast-enter-active {
  transition: all 0.3s ease-out;
}

.update-toast-leave-active {
  transition: all 0.2s ease-in;
}

.update-toast-enter-from {
  opacity: 0;
  transform: translateX(-50%) translateY(20px);
}

.update-toast-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(20px);
}
</style>
